import { render, staticRenderFns } from "./do-you-have-an-account.vue?vue&type=template&id=965899d6&lang=pug&"
import script from "./do-you-have-an-account.vue?vue&type=script&lang=js&"
export * from "./do-you-have-an-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports